import { GameEntity } from '@okletsplay/core';
import { JSONSchemaType } from 'ajv';
import { useDefaultTournamentSettingsForm } from '../../tournaments/hooks';

type SchemaType = JSONSchemaType<{
  teamsSettings: JSONSchemaType<unknown>;
  matchSetupSettings: JSONSchemaType<unknown>;
}>;

const EMPTY_OBJECT = { type: 'object', properties: {} };

export const useDynamicSchemaForTournamentFromGame = (game: GameEntity | undefined): SchemaType => {
  const { teamsSettingsSchema, matchSetupSettingsSchema } = useDefaultTournamentSettingsForm(game);

  return {
    type: 'object',
    properties: {
      teamsSettings: teamsSettingsSchema ?? EMPTY_OBJECT,
      matchSetupSettings: matchSetupSettingsSchema ?? EMPTY_OBJECT,
    },
    required: ['teamsSettings', 'matchSetupSettings'],
  };
};

export const useDynamicSchemaForMatchFromGame = (
  game: GameEntity | undefined
): JSONSchemaType<{ matchSetupSettings: JSONSchemaType<unknown> }> | undefined => {
  const matchSetupSettings = game?.matchesConfiguration?.matchSetupSettings;

  if (!matchSetupSettings) return undefined;

  return {
    type: 'object',
    properties: {
      matchSetupSettings: matchSetupSettings,
    },
    required: ['matchSetupSettings'],
  } as unknown as JSONSchemaType<{ matchSetupSettings: JSONSchemaType<unknown> }>;
};
